import { createSlice } from "@reduxjs/toolkit";


export const elevesSlice = createSlice({
    name: 'eleves',
    initialState:{},
    reducers: { // 
       
        initEleves: (currentState, action) => {
           
            let newList = [].concat(action.payload);
            return newList;

        },
        modifyEleve: (currentState, action) => {
           
            let newList = currentState.filter((eleve)=>eleve.id!=action.payload.id);
            newList.push(action.payload);
            newList.sort((e1,e2)=>e1.id>e2.id?1:-1);
            return newList;

        },
        addEleve: (currentState, action) => {
           
            let newList = currentState;
            newList.push(action.payload);
            newList.sort((e1,e2)=>e1.id>e2.id?1:-1);
            return newList;

        },
        
    }
});

